import { computed } from "vue";
import { styles } from "@/reports/reportStyles";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useConfigStore } from "@/stores/config";
import { getReportFooter, getReportHeader } from "@/reports/ReportUtil";
import { useInspectionStore } from "@/stores/inspection";
import getFeaturesHighway from "@/composables/featuresHighway";
import getFeaturesRailroad from "@/composables/featuresRailroad";
import getFeaturesWaterway from "@/composables/featuresWaterway";
import { sortStructure } from "@/util/sortStructure";

function setFeaturesDocDefinition(structure) {
  const configStore = useConfigStore();

  const FeaturesDetails = [];
  sortStructure(structure, "structureRoadways", "onUnder");
  getFeaturesInspectionDetails(FeaturesDetails, structure);

  let docDefinition = {
    header: function () {
      return getReportHeader("Features Page", structure);
    },
    footer: function (currentPage, pageCount) {
      return getReportFooter(currentPage, pageCount);
    },
    pageMargins: [20, 70, 20, 50],
    content: [
      { text: "", pageHeaderText: "Features Page" },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Clearance Information",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        table: {
          headerRows: 0,
          widths: ["48%", "2%", "50%"],

          body: [
            [
              {
                text: "Minimum Vert Clr",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
              {
                text: "",
                fillColor: "#ffffff",
                alignment: "center",
                style: ["sectionHeader"],
              },
              {
                text: "Minimum Lateral Clr",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 5, 20, 0],
      },
      {
        table: {
          headerRows: 0,
          widths: ["24%", "26%", "26%", "*"],
          body: [
            [
              { text: "SC.01 Over Structure: ", bold: true },
              {
                text: structure?.structureBridge?.vclrOver + " ft",
              },
              { text: "SC.04 Reference Feature: ", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.MINIMUM_UNDERCLEARANCE,
                  structure?.structureBridge?.refHuc,
                ),
              },
            ],
            [
              { text: "SC.02 Under (Reference): ", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.MINIMUM_UNDERCLEARANCE,
                  structure?.structureBridge?.refVuc,
                ),
              },
              { text: "SC.05 Under Right: ", bold: true },
              {
                text: structure?.structureBridge?.hclrUrt + " ft",
              },
            ],
            [
              { text: "SC.03 Under Clr: ", bold: true },
              {
                text: structure?.structureBridge?.vclrUnder + " ft",
              },
              { text: "SC.06 Under Left: ", bold: true },
              {
                text: structure?.structureBridge?.hclrUlt + " ft",
              },
            ],
          ],
        },
        margin: [20, 0, 20, 5],
        layout: "noBorders",
      },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Navigation Control",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 0, 20, 0],
      },
      {
        table: {
          headerRows: 0,
          widths: ["24%", "26%", "26%", "*"],
          body: [
            [
              { text: "B.N.01 Navigable Waterway?: ", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.NAVIGATION_CONTROL,
                  structure?.structureBridge?.navCntrol,
                ),
              },
              { text: "B.N.02 Min. Vert. Clr: ", bold: true },
              {
                text: structure?.structureBridge?.lftbrnavcl + " ft",
              },
            ],
            [
              { text: "B.N.05 Nav Horiz Clr: ", bold: true },
              {
                text: structure?.structureBridge?.navHc + " ft",
              },
              { text: "B.N.03 Nav Vert Clr: ", bold: true },
              {
                text: structure?.structureBridge?.navVc + " ft",
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 0, 20, 0],
      },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Feature Intersection Details",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 5, 0, 5],
      },
      FeaturesDetails?.map((a) => a),
    ],
    styles: styles,

    defaultStyle: {
      fontSize: 10,
    },
  };
  return docDefinition;
}

function getFeaturesInspectionDetails(FeaturesDetails, structure) {
  const inspectionStore = useInspectionStore();
  let mergedTableData = computed(() => inspectionStore.getFeatureIntersectionTableData());

  for (const detail of mergedTableData.value ?? []) {
    if (detail?.featureType === "1" || detail?.featureType === "4") {
      FeaturesDetails.push(getFeaturesHighway(detail, structure));
    } else if (detail?.featureType === "2") {
      FeaturesDetails.push(getFeaturesRailroad(detail, structure));
    } else if (detail?.featureType === "3") {
      FeaturesDetails.push(getFeaturesWaterway(detail));
    }
  }
}

export { setFeaturesDocDefinition };
